/**
 * DEV-1991 (эпик DEV-1980). Единая форма задачи — общая для карточки сделки и
 * карточки клиента.
 *
 * Раньше строки формы жили в словаре сделок (`deals.detail.task*`), а карточка
 * клиента их же и заимствовала: подсказка про календарь, например, обещала
 * «календарь ответственного ПО СДЕЛКЕ» и у клиентской задачи была неправдой.
 * Форма стала общей — и словарь у неё теперь свой, нейтральный к владельцу.
 *
 * Названия типов задач сюда НЕ кладём: справочник редактируемый, имена приходят
 * с бэка на локали запроса (см. taskTypes).
 */

const ru = {
  addTitle: 'Новая задача',
  editTitle: 'Задача',
  description: 'Описание',
  descriptionPlaceholder: 'Что нужно сделать',
  type: 'Тип',
  typeNone: 'Без типа',
  assignee: 'Исполнитель',
  dueDate: 'Дата',
  dueTime: 'Время',
  calendarHint: 'Задача со сроком появится в календаре исполнителя',
  reminderCustomHours: 'За N часов',
  reminderHours: 'Часов до срока',
}

const en = {
  addTitle: 'New task',
  editTitle: 'Task',
  description: 'Description',
  descriptionPlaceholder: 'What needs to be done',
  type: 'Type',
  typeNone: 'No type',
  assignee: 'Assignee',
  dueDate: 'Date',
  dueTime: 'Time',
  calendarHint: 'A task with a due date appears in the assignee’s calendar',
  reminderCustomHours: 'N hours before',
  reminderHours: 'Hours before due',
}

const vn = {
  addTitle: 'Công việc mới',
  editTitle: 'Công việc',
  description: 'Mô tả',
  descriptionPlaceholder: 'Cần làm gì',
  type: 'Loại',
  typeNone: 'Không có loại',
  assignee: 'Người thực hiện',
  dueDate: 'Ngày',
  dueTime: 'Giờ',
  calendarHint: 'Công việc có hạn chót sẽ xuất hiện trong lịch của người thực hiện',
  reminderCustomHours: 'Trước N giờ',
  reminderHours: 'Số giờ trước hạn',
}

export const taskFormMessages = {
  ru: { tasks: { form: ru } },
  en: { tasks: { form: en } },
  vn: { tasks: { form: vn } },
}
